module.exports = __webpack_public_path__ + "static/media/sc30_styleframe01_v001.31b32373.webp";